var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section section-background-grey border-bottom-section" },
    [
      _c("div", { staticClass: "section-content" }, [
        _c("div", { staticClass: "columns is-centered is-vcentered" }, [
          _vm._m(0),
          _c("div", { staticClass: "column has-text-centered-md" }, [
            _c(
              "div",
              {
                staticClass: "title is-spaced",
                staticStyle: { "margin-bottom": ".5rem" },
              },
              [_vm._v(_vm._s(_vm.$t("about.title_start_workout")))]
            ),
            _c(
              "p",
              {
                staticClass: "subtitle",
                staticStyle: { "margin-bottom": ".5rem" },
              },
              [_vm._v(_vm._s(_vm.$t("about.solutions_languages")))]
            ),
          ]),
          _c("div", { staticClass: "column is-narrow" }, [
            _c(
              "p",
              {
                staticClass: "subtitle has-text-centered",
                staticStyle: { "margin-bottom": ".5rem" },
              },
              [_vm._v(_vm._s(_vm.$t("about.download_app")))]
            ),
            _c(
              "div",
              {
                staticClass: "app-container justify-center-md",
                staticStyle: { "justify-content": "flex-end" },
              },
              [_c("android-app"), _c("ios-app")],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow has-text-centered" }, [
      _c("img", {
        staticStyle: { width: "100px", display: "inline-block" },
        attrs: { src: "/icon-big.png" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }